import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import Layout from '../components/Layout';
import '../styles/App.css';
import '../styles/Form.css';
import '../styles/Home.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export default function BlogGenerator() {
  const [title, setTitle] = useState('');
  const [keywords, setKeywords] = useState('');
  const [tone, setTone] = useState('Casual');
  const [wordLimit, setWordLimit] = useState(500);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function generateBlog(ev) {
    ev.preventDefault();
    setLoading(true);
    try {
      const response = await apiFetch('/generate-blog', {
        method: 'POST',
        body: JSON.stringify({ title, keywords, tone, wordLimit }),
      });

      if (response.ok) {
        const data = await response.json();
        MySwal.fire({
          title: 'Generated!',
          text: 'Blog draft generated. Redirecting to editor...',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        });
        navigate('/create', {
          state: {
            title,
            content: data.content,
            summary: `Draft generated by AI with keywords: ${keywords}`,
          },
        });
      } else {
        const errData = await response.json();
        throw new Error(errData.error || 'Failed to generate');
      }
    } catch (err) {
      MySwal.fire({
        title: 'Error',
        text: err.message || 'Failed to generate blog post. Check API Key.',
        icon: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Layout />
      <div className="form-page">
        {/* Decorative Blobs */}
        <div className="form-blob form-blob--1" />
        <div className="form-blob form-blob--2" />

        <div className="form-container">
          <h1>✨ AI Blog Generator</h1>
          <p className="subtitle">Let AI write your first draft instantly</p>

          <form onSubmit={generateBlog}>
            <div className="form-group">
              <label className="form-label">Working Title</label>
              <input
                type="text"
                className="form-input"
                placeholder="E.g., The Future of Web Dev"
                value={title}
                onChange={ev => setTitle(ev.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Keywords</label>
              <input
                type="text"
                className="form-input"
                placeholder="Comma separated (e.g., React, AI, frontend)"
                value={keywords}
                onChange={ev => setKeywords(ev.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Desired Tone</label>
              <select
                className="form-select"
                value={tone}
                onChange={ev => setTone(ev.target.value)}
              >
                <option value="Casual">Casual & Conversational</option>
                <option value="Formal">Formal & Professional</option>
                <option value="Technical">Technical & Detailed</option>
                <option value="Humorous">Humorous & Lighthearted</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Approx. Word Limit ({wordLimit})</label>
              <input
                type="number"
                className="form-input"
                value={wordLimit}
                onChange={ev => setWordLimit(ev.target.value)}
                required
                min="100"
                max="2000"
              />
            </div>

            <div className="form-actions">
              <button
                type="submit"
                disabled={loading}
                className="btn btn--primary"
                style={{
                  background: loading ? '#aaa' : undefined,
                  boxShadow: loading ? 'none' : undefined,
                }}
              >
                {loading ? '🔮 Generating...' : 'Generate Draft'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
